mutation InvoiceSigningApprovalCreate($input: InvoiceSigningApprovalCreateInput!) {
  invoiceSigningApprovalCreate(
    input: $input
  ) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}